import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Button } from '@synergy-marine-group/synergy-ui';
import Header from '../common/Header';
import SubHeader from '../common/SubHeader';
import SearchBar from '../common/SearchBar';
import ButtonComponent from '../common/ButtonComponent';
import FixedBudgetVesselAccCodeTable from './FixedBudgetVesselAccCodeTable';
import UploadFixedBudgetVesselAccCodeModal from './UploadFixedBudgetVesselAccCodeModal';
import ConfirmDelete from '../Modal/ConfirmDelete';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';
import { resetFilter } from '../../features/fliter/filterSlice';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { resetPage } from '../../features/pagecount/pageSlice';
import uploadIcon from '../../images/icons/upload.svg';
import downloadFixedBudgetVesselAccCodeTemplate from './queries/downloadFixedBudgetVesselAccCodeTemplate';
import deleteFixedBudgetVesselAccCodes from './queries/deleteFixedBudgetVesselAccCodes';
import showAlert from '../../utils/alert';

const FixedBudgetVesselAccountCode = () => {
  const [search, setsearch] = useState('');
  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
  const [uploadModal, setUploadModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const policies = returnPolicies();
  const history = useHistory();
  const dispatch = useDispatch();
  const { mutate: downloadTemplate } = downloadFixedBudgetVesselAccCodeTemplate();
  const {
    mutate: deleteItems,
    isSuccess: isDeleteSuccess,
    isError: isDeleteError,
    reset: resetDelete
  } = deleteFixedBudgetVesselAccCodes();

  const canAccessPage = policies?.sapPoAdminPolicies?.canAccess === true;
  const canManagePage = canAccessPage
    || policies?.sapPoAdminPolicies?.canEdit === true;

  const handleSearch = (value) => {
    setsearch(value);
  };

  useEffect(() => {
    dispatch(resetFilter());
    dispatch(resetPage());
    dispatch(resetVendorFilter());
  }, []);

  useEffect(() => {
    if (policies?.sapPoAdminPolicies?.canAccess === false) {
      history.push('/');
    }
  }, [policies]);

  useEffect(() => {
    if (isDeleteSuccess) {
      setDeleteModal(false);
      setSelectedIds([]);
      showAlert('Deleted Successfully', 'success');
      resetDelete();
    }
  }, [isDeleteSuccess]);

  useEffect(() => {
    if (isDeleteError) {
      showAlert('Something went wrong', 'error');
      setDeleteModal(false);
      resetDelete();
    }
  }, [isDeleteError]);

  return (
    <>
      <ToastContainer
        enableMultiContainer
        containerId="fixed-budget-acc-toast"
        className="fixed-budget-acc-toast-container"
        position="top-right"
        autoClose={false}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {canAccessPage && (
        <div className="md:w-full fixed-budget-vessel-account-codes-page">
          <Header
            parentPageLink="/"
            currentPage="Fixed Budget Vessel Account Codes List"
            headerName="Fixed Budget Vessel Account Codes"
          />
          <div className="manning-wrapper">
            <SubHeader
              searchComponent={(
                <SearchBar
                  handleSearch={handleSearch}
                  search={search}
                  placeholder="Search Fixed Budget Account Code (Minimum 3 characters)"
                  additionalClassName="search-input-width"
                />
              )}
              downloadButton={(
                <>
                  {canManagePage && (
                    <Button
                      type="button"
                      className="max-w-none items-center"
                      onClick={() => setDeleteModal(true)}
                      size="large"
                      variant="outlined"
                      rounded
                      disabled={selectedIds.length === 0}
                    >
                      <div className="flex flex-row font-montserrat text-gray-500 uppercase text-sm items-center">
                        Delete (
                        {selectedIds.length}
                        )
                      </div>
                    </Button>
                  )}
                  {canManagePage && (
                    <ButtonComponent
                      handleClick={() => downloadTemplate()}
                      name="DOWNLOAD TEMPLATE"
                    />
                  )}
                </>
              )}
              addButtonComponent={canManagePage && (
                <ButtonComponent
                  handleClick={() => setUploadModal(true)}
                  name="UPLOAD CSV"
                  icon={uploadIcon}
                />
              )}
            />

            <FixedBudgetVesselAccCodeTable
              policies={policies}
              canManage={canManagePage}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              search={search}
              pageNumber={pageNumber}
              setpageNumber={setpageNumber}
              rowsCount={rowsCount}
              setrowsCount={setrowsCount}
            />
          </div>

          {uploadModal && (
            <UploadFixedBudgetVesselAccCodeModal
              open={uploadModal}
              setOpen={setUploadModal}
            />
          )}

          {deleteModal && (
            <ConfirmDelete
              modal={deleteModal}
              setModal={setDeleteModal}
              handleDelete={() => deleteItems(selectedIds)}
              subMessage={`This will permanently delete ${selectedIds.length} selected fixed budget account code record(s).`}
              message="Delete"
            />
          )}
        </div>
      )}
    </>
  );
};

export default FixedBudgetVesselAccountCode;
